import React, { Fragment, useState } from "react";
import Scrollspy from "react-scrollspy";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import {
  FiHome,
  FiUser,
  FiZap,
  FiFileText,
  FiBriefcase,
  FiAward,
  FiBookOpen,
  FiPhoneOutgoing,
} from "react-icons/fi";

const Header = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      {/* Header */}
      <div className="mob-header">
        <button className="toggler-menu" onClick={handleClick}>
          <div className={click ? "active" : ""}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </div>
      {/* End Header */}

      {/* nav bar */}
      <header className={click ? "header-left menu-open" : "header-left "}>
        <div className="scroll-bar">
          <Link onClick={scrollToTop}><img src="img/logo.png" alt="logo" /></Link>
          {/* End htl-top */}

          <Scrollspy
            className="nav nav-menu"
            items={["home", "about", "skills", "experience", "portfolio", "achievements", "blog", "contactus"]}
            currentClassName="active"
            offset={-30}
          >
            <li>
              <a className="nav-link " href="#home" data-tip data-for="HOME" onClick={handleClick}>
                <FiHome />
                <ReactTooltip id="HOME" place="top" type="dark" effect="float"><span>Home</span></ReactTooltip>
              </a>
            </li>
            <li>
              <a className="nav-link" href="#about" data-tip data-for="ABOUT" onClick={handleClick}>
                <FiUser />
                <ReactTooltip id="ABOUT" place="top" type="dark" effect="float"><span>About</span></ReactTooltip>
              </a>
            </li>
            <li>
              <a className="nav-link" href="#skills" data-tip data-for="SKILLS" onClick={handleClick}>
                <FiZap />
                <ReactTooltip id="SKILLS" place="top" type="dark" effect="float"><span>Skills</span></ReactTooltip>
              </a>
            </li>
            <li>
              <a className="nav-link" href="#experience" data-tip data-for="EXPERIENCE" onClick={handleClick}>
                <FiFileText />
                <ReactTooltip id="EXPERIENCE" place="top" type="dark" effect="float"><span>Experience</span></ReactTooltip>
              </a>
            </li>
            <li>
              <a className="nav-link" href="#portfolio" data-tip data-for="WORK" onClick={handleClick}>
                <FiBriefcase />
                <ReactTooltip id="WORK" place="top" type="dark" effect="float"><span>Portfolio</span></ReactTooltip>
              </a>
            </li>
            <li>
              <a className="nav-link" href="#achievements" data-tip data-for="ACHIEVEMENTS" onClick={handleClick}>
                <FiAward />
                <ReactTooltip id="ACHIEVEMENTS" place="top" type="dark" effect="float"><span>Achievements</span></ReactTooltip>
              </a>
            </li>
            <li>
              <a className="nav-link" href="#blog" data-tip data-for="BLOG" onClick={handleClick}>
                <FiBookOpen />
                <ReactTooltip id="BLOG" place="top" type="dark" effect="float"><span>Blog</span></ReactTooltip>
              </a>
            </li>
            <li>
              <a className="nav-link" href="#contactus" data-tip data-for="CONTACT" onClick={handleClick}>
                <FiPhoneOutgoing />
                <ReactTooltip id="CONTACT" place="top" type="dark" effect="float"><span>Contact</span></ReactTooltip>
              </a>
            </li>
          </Scrollspy>
        </div>
      </header>
      {/* End Header */}
    </>
  );
};

export default Header;
